import { render } from "./AuthPage.vue?vue&type=template&id=a4df1182&scoped=true&ts=true"
import script from "./AuthPage.vue?vue&type=script&lang=ts"
export * from "./AuthPage.vue?vue&type=script&lang=ts"

import "./AuthPage.vue?vue&type=style&index=0&id=a4df1182&scoped=true&lang=scss"

import exportComponent from "/Users/aleksandrvasilevic/Documents/Dev/WEB/Pets/phone-book/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4df1182"]])

export default __exports__